export default __webpack_public_path__ + "static/media/main.0c2d14ff.png";